// Original vocabulary. Role tags constrain where a noun may be used.
export default [
  {
    "id": "animal-sticker",
    "role": "countable",
    "singular": "animal sticker",
    "plural": "animal stickers",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-lion",
    "role": "countable",
    "singular": "toy lion",
    "plural": "toy lions",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-dog",
    "role": "countable",
    "singular": "toy dog",
    "plural": "toy dogs",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-cat",
    "role": "countable",
    "singular": "toy cat",
    "plural": "toy cats",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-horse",
    "role": "countable",
    "singular": "toy horse",
    "plural": "toy horses",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-duck",
    "role": "countable",
    "singular": "toy duck",
    "plural": "toy ducks",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-rabbit",
    "role": "countable",
    "singular": "toy rabbit",
    "plural": "toy rabbits",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-turtle",
    "role": "countable",
    "singular": "toy turtle",
    "plural": "toy turtles",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-panda",
    "role": "countable",
    "singular": "toy panda",
    "plural": "toy pandas",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "toy-bear",
    "role": "countable",
    "singular": "toy bear",
    "plural": "toy bears",
    "tags": [
      "portable"
    ]
  },
  {
    "id": "ribbon",
    "role": "measurable",
    "singular": "ribbon",
    "plural": "ribbons",
    "tags": [
      "length"
    ]
  },
  {
    "id": "rope",
    "role": "measurable",
    "singular": "rope",
    "plural": "ropes",
    "tags": [
      "length"
    ]
  },
  {
    "id": "leash",
    "role": "measurable",
    "singular": "leash",
    "plural": "leashes",
    "tags": [
      "length"
    ]
  },
  {
    "id": "fence-panel",
    "role": "measurable",
    "singular": "fence panel",
    "plural": "fence panels",
    "tags": [
      "length"
    ]
  },
  {
    "id": "basket",
    "role": "container",
    "singular": "basket",
    "plural": "baskets",
    "tags": []
  },
  {
    "id": "box",
    "role": "container",
    "singular": "box",
    "plural": "boxes",
    "tags": []
  },
  {
    "id": "bag",
    "role": "container",
    "singular": "bag",
    "plural": "bags",
    "tags": []
  },
  {
    "id": "tray",
    "role": "container",
    "singular": "tray",
    "plural": "trays",
    "tags": []
  },
  {
    "id": "keeper",
    "role": "person",
    "singular": "keeper",
    "plural": "keepers",
    "tags": []
  },
  {
    "id": "veterinarian",
    "role": "person",
    "singular": "veterinarian",
    "plural": "veterinarians",
    "tags": []
  },
  {
    "id": "visitor",
    "role": "person",
    "singular": "visitor",
    "plural": "visitors",
    "tags": []
  },
  {
    "id": "volunteer",
    "role": "person",
    "singular": "volunteer",
    "plural": "volunteers",
    "tags": []
  },
  {
    "id": "feeding-session",
    "role": "action",
    "singular": "feeding session",
    "plural": "feeding sessions",
    "tags": []
  },
  {
    "id": "nature-walk",
    "role": "action",
    "singular": "nature walk",
    "plural": "nature walks",
    "tags": []
  },
  {
    "id": "animal-count",
    "role": "action",
    "singular": "animal count",
    "plural": "animal counts",
    "tags": []
  },
  {
    "id": "guided-visit",
    "role": "action",
    "singular": "guided visit",
    "plural": "guided visits",
    "tags": []
  },
  {
    "id": "shelter",
    "role": "structure",
    "singular": "shelter",
    "plural": "shelters",
    "tags": []
  },
  {
    "id": "fence",
    "role": "structure",
    "singular": "fence",
    "plural": "fences",
    "tags": []
  },
  {
    "id": "zoo",
    "role": "place",
    "singular": "zoo",
    "plural": "zoos",
    "tags": []
  },
  {
    "id": "park",
    "role": "place",
    "singular": "park",
    "plural": "parks",
    "tags": []
  }
];
